<div class="row d-flex align-items-center m-2">
  <a [dsRedirect]="url">
    <div class="row">
      <div class="col-2" *ngIf="metric && metric.icon">
        <img class="icon-size" [src]="metric.icon" alt="google scholar icon"/>
      </div>
      <div class="col">
        <div class="d-flex justify-content-center">
          <div class="font-weight-bold">
            {{ "item.page.metric.label." + metric.metricType | translate }}
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="btn btn-overlap-container">
      {{ "item.page.metric.label.view-detail-btn" | translate }}
    </button>
  </a>
</div>
